import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import isPage from '../hoc/isPage';


class InventoryDeleteRulePage extends Component {

	static propTypes = {
		handleCloseModal : PropTypes.func,
		handleRefreshListing : PropTypes.func,
		ruleID : PropTypes.number
	}
	state = {
		isRuleDeleted : false
	}
	handleSubmit = () => {
		let ruleID = this.props.ruleID;

		// run the delete rule endpoint

		this.props.deleteData(`/api/portal/inventory/shapingRule/${ruleID}/DeleteRule`).then(response => {
			if (response.status === 200){
				this.props.alert("success",this.props.returnLocalizedString("m0036"),this.props.returnLocalizedString("m0171"));

				this.props.handleRefreshListing();

				// close the modal
				this.props.handleCloseModal();
			}
			else {
				this.showError();
			}
		}).catch(error => {
			this.showError();
		});

		

		//this.props.handleDeleteRule();
	}
	showError = () => {
		this.props.alert("error",this.props.returnLocalizedString("m0023"),this.props.returnLocalizedString("m0172"));
	}
	render(){

		//!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
		//!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
		//!DBTRANS! @m0171@ The inventory shaping rule was sucessfully deleted! !DEVNOTE! Action status 
		//!DBTRANS! @m0172@ The The inventory shaping rule could not be deleted. Please try again. !DEVNOTE! Action status 
		//!DBTRANS! @m0173@ The rule has been deleted. !DEVNOTE! Action status 
		//!DBTRANS! @m0174@ Are you sure you want to delete this rule? !DEVNOTE! Option dialog
		//!DBTRANS! @m0175@ Close !DEVNOTE! Option label
		//!DBTRANS! @m0176@ Yes !DEVNOTE! Option label

		return (
			<div>
				{this.state.isRuleDeleted ? (
					<React.Fragment>
						{this.props.returnLocalizedString("m0173")}
					</React.Fragment>
				) : (
					<React.Fragment>
						{this.props.returnLocalizedString("m0174")}
					</React.Fragment>
				)}

				
				<DialogActionsBar>
					<Button className="k-button" onClick={this.props.handleCloseModal}>{this.props.returnLocalizedString("m0175")}</Button>
					{!this.state.isRuleDeleted && 	
						<Button className="k-button k-primary" onClick={this.handleSubmit}>{this.props.returnLocalizedString("m0176")}</Button>
					}
					
				</DialogActionsBar>
			</div>
		);
	}
}
export default isPage(InventoryDeleteRulePage);


// WEBPACK FOOTER //
// ./src/containers/InventoryDeleteRulePage.js